// extracted by mini-css-extract-plugin
export var dataCell = "_k2-2";
export var dataRow = "_k2-0";
export var headerRow = "_k2-1";